import { Outlet } from 'react-router';

export const GuestLayout = () => {
  return <Outlet />;
};
